"use client";
import { Button } from "./ui/button";
import { createClient } from "@/lib/supabase/auth.client";

type LoginButtonProps = {
  children: React.ReactNode;
};
export function LoginButton({ children }: LoginButtonProps) {
  const supabase = createClient();

  const handleLogin = async () => {
    await supabase.auth.signInWithOAuth({
      provider: "slack",
      options: {
        redirectTo: `${location.origin}/auth/callback`,
      },
    });
  };

  return (
    <Button className="w-fit" onClick={handleLogin}>
      {children}
    </Button>
  );
}
